// extracted by mini-css-extract-plugin
module.exports = {"divider":"SessionTimeout_divider__lRKa_","message":"SessionTimeout_message__1EyjX"};